export default {
  API: {
    BASE_URL: process.env.VUE_APP_API_URL,
    TIMEOUT: 6000,
  },
};
